<template>
  <div class="listing-confirmation">
    <h3 class="wt-bold font-md mb-6 lh-tight">
      Our A Perfect Space team will review your submission and be in touch with
      next steps.
    </h3>
    <!-- <a
        v-if="$store.getters['user/account'] && !$store.getters['user/stripeConnectIsOnboarded']"
        class="button tertiary interactive mb-4"
        @click="goToOnBoarding"
    >
      Setup payment details
    </a> -->
    <a
      v-if="$store.getters['user/account']"
      class="button tertiary interactive"
      @click="goToDashboard"
    >
      Take me to my dashboard
    </a>
  </div>
</template>

<script>
import BaseModal from "../Base";

export default {
  extends: BaseModal,
  props: {
    data: {
      type: Object,
      required: false,
    },
  },
  methods: {
    goToDashboard() {
      this.$store.commit('findspace/navigateToSubpage', { page: 'listings', subpage: 'home' })
      this.$emit("cancel");
    },
    goToOnBoarding() {
      this.$store.commit('findspace/navigateToSubpage', { page: 'account', subpage: 'account' })
      this.$emit("cancel");
    },
  },
};
</script>
